module.exports = {
  EXTERNAL_TRANSFER: 'ExternalTransfer',
  INTERNAL_TRANSFER: 'InternalTransfer',
  PAYMENT_SLIP: 'PaymentSlip',
  PIX_PAYMENT: 'PixPayment',
  PIX_REVERSAL_INBOUND: 'PixReversalInbound',
  PIX_PAYMENT_INBOUND: 'PixPaymentInbound',
  PIX_REVERSAL: 'PixReversal',
  DICT_CLAIM: 'DictClaim',
  DICT_CID_FILE: 'DictCidFile',
  BILL: 'Bill',
  INFRACTION_REPORT: 'InfractionReport',
  DICT_REFUND: 'DictRefund',
  PAYMENT_INITIATION_PIX: 'PaymentInitiationPix'
};
